import React from 'react'
// import image1 from "../../../Icons/tootalBooking.png";


const TotalBookingAmount = ({ borderLeft, borderColor, imagesourcs,text,value }) => {
  return (
    <section>
      <div className='container'>
        <div className='row' >
          <div className='col' style={{ display: "flex",flexDirection: "column-reverse", alignItems: "center", height: '150px', backgroundColor: "white", borderRadius: "7px", borderColor: borderColor, padding: "20px", borderLeft: borderLeft }}>
            <div>
              <h2 style={{backgroundColor:"white",color:"#6A6A6A",fontWeight:"bold",fontSize:"31px"}}>{value}</h2>
              <span >{text}</span>
            </div>
            <div style={{ marginRight: '1rem', color: "blue" }}>
              <img
                src={imagesourcs}
                alt='Booking-img'
                // className={amountImage}
                style={{
                  width: '2rem',
                  height: '2rem',
                  marginLeft: "27px"
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>

  )
}

export default TotalBookingAmount